var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#unify_svg__clip0_1841_799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 2.2A1.2 1.2 0 012.2 1h3.6A1.2 1.2 0 017 2.2v3.6A1.2 1.2 0 015.8 7H2.2A1.2 1.2 0 011 5.8V2.2zM23 4a3 3 0 11-6 0 3 3 0 016 0zM14.91 5.85l-2.27-4.445a.707.707 0 00-1.28 0L9.09 5.85C8.825 6.368 9.177 7 9.73 7h4.54c.553 0 .905-.632.64-1.15zM18 14l-6 3v6l6-3v-6z",
    fill: "#ADC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.375 2.2C.375 1.192 1.192.375 2.2.375h3.6c1.008 0 1.825.817 1.825 1.825v3.6A1.825 1.825 0 015.8 7.625H2.2A1.825 1.825 0 01.375 5.8V2.2zM2.2 1.625a.575.575 0 00-.575.575v3.6c0 .318.257.575.575.575h3.6a.575.575 0 00.575-.575V2.2a.575.575 0 00-.575-.575H2.2zM20 1.625a2.375 2.375 0 100 4.75 2.375 2.375 0 000-4.75zM16.375 4a3.625 3.625 0 117.25 0 3.625 3.625 0 01-7.25 0zM10.804 1.121a1.332 1.332 0 012.392 0l2.27 4.444c.447.874-.11 2.06-1.196 2.06H9.73c-1.086 0-1.643-1.186-1.197-2.06l2.27-4.444zm1.158.515a.127.127 0 00-.045.054l-2.27 4.444a.191.191 0 00.002.181c.03.053.061.06.08.06h4.541c.02 0 .052-.007.08-.06a.191.191 0 00.003-.181l-2.27-4.444a.127.127 0 00-.045-.054.072.072 0 00-.076 0zM5.671 13.468a.625.625 0 01.609-.027l6 3a.625.625 0 01.345.559v6a.625.625 0 01-.905.559l-6-3A.625.625 0 015.375 20v-6c0-.217.112-.418.296-.532zm.954 1.543v4.603l4.75 2.375v-4.603l-4.75-2.375z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.329 13.468a.625.625 0 01.296.532v6a.625.625 0 01-.346.559l-6 3a.625.625 0 01-.904-.559v-6c0-.237.134-.453.345-.559l6-3a.625.625 0 01.609.027zm-5.704 3.918v4.603l4.75-2.375V15.01l-4.75 2.375z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14l-6-3-6 3 6 3 6-3z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.72 10.441a.625.625 0 01.56 0l6 3a.625.625 0 010 1.118l-6 3a.625.625 0 01-.56 0l-6-3a.625.625 0 010-1.118l6-3zM7.398 14L12 16.301 16.602 14 12 11.699 7.398 14z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.375 11V7h1.25v4h-1.25zM7.526 12.99A6.397 6.397 0 013.375 7h1.25a5.147 5.147 0 003.34 4.82l4.255 1.595-.44 1.17-4.254-1.595z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.474 12.99A6.397 6.397 0 0020.625 7h-1.25a5.147 5.147 0 01-3.34 4.82l-4.255 1.595.44 1.17 4.254-1.595z",
    fill: "#2E2E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "unify_svg__clip0_1841_799"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnify);
export default __webpack_public_path__ + "static/media/unify.e163528a8b3c811d11a5feba831cf5b6.svg";
export { ForwardRef as ReactComponent };